import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';

// TODO Update `Filter.jsx` so it is more configurable instead of using this component
export default class MultiSelectStaticFilterChecks extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    dropdownOptions: PropTypes.string,
    className: PropTypes.string,
  }

  static defaultProps = {
    dropdownOptions: '',
    options: [],
    className: '',
  }

  constructor(props) {
    super(props);

    this.state = {
      filterInputValue: '',
      filteredOptions: this.props.options,
    };
  }

  handleGoButtonClick = () => {
    let checkedValues = this.props.options.map(option => {
      const checkBox = $(`input#${this.props.id}-${option.id}`);
      return (checkBox.prop('checked') === true ? checkBox.prop('value') : '');
    });
    checkedValues = checkedValues.filter(option => option !== '').join('&');

    let otherParams = qs.parse(window.location.search.slice(1));
    if (otherParams.page) delete otherParams.page;
    if (otherParams[this.props.id]) delete otherParams[this.props.id];
    otherParams = qs.stringify(otherParams, { arrayFormat: 'brackets' });

    const search = `?${checkedValues}&${otherParams}`;

    // Note: this isn't being listened to in application.js by default.
    // As is, you'll need to set a listener using 'router.listen'
    router.push({ pathname: location.pathname, search });
  }

  search(query, text) {
    const lowerQ = query.toLowerCase();
    const lowerT = text.toLowerCase();
    return lowerQ.split(' ').map(term => lowerT.indexOf(term) >= 0).reduce((acc, val) => (acc && val), true);
  }

  handleFilterChange = (e) => {
    const value = e.target.value;

    const filteredOptions = [];
    this.props.options.forEach(item => {
      if (this.search(value, item.name)) {
        filteredOptions.push(item);
      }
    });

    this.setState({
      filterInputValue: value,
      filteredOptions,
    });
  }

  renderOption = (option) => {
    const params = qs.parse(window.location.search.slice(1));
    const values = params[this.props.id] = params[this.props.id] || [];
    const checked = values.indexOf(option.id) > -1;

    const checkedProps = {};
    if (checked) {
      checkedProps.defaultChecked = true;
    }
    const value = {};
    value[`${this.props.id}[]`] = option.id;

    return (
      <li className="checkbox" key={`key-${this.props.id}-${option.id}`}>
        <label htmlFor={`${this.props.id}-${option.id}`}>
          <input
            {...checkedProps}
            type="checkbox"
            id={`${this.props.id}-${option.id}`}
            value={qs.stringify(value, { arrayFormat: 'brackets' })}
          />
          {option.name}
        </label>
      </li>
    );
  }

  renderFilterInput() {
    return (
      <input
        placeholder="Start typing to filter results"
        type="text"
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
        value={this.state.filterInputValue}
        onChange={this.handleFilterChange}
        className="u-mb-0"
      />
    );
  }

  renderGoButton() {
    return (
      <input
        className="Button Button--small"
        type="submit"
        value="Go"
        onClick={this.handleGoButtonClick}
        data-disableable="true"
        data-disable-message="Go"
      />
    );
  }

  render() {
    const params = qs.parse(window.location.search.slice(1));
    const options = this.state.filteredOptions.map(this.renderOption);
    const className = this.props.className;

    let filterInput = null;
    if (this.props.options.length > 4) {
      filterInput = this.renderFilterInput();
    }
    const goButton = this.renderGoButton();

    const style = {
      display: 'inline-block',
      marginLeft: 0,
      width: '100%',
    };

    return (
      <li className={this.props.id in params ? `${className} is-active` : className}>
        <div id={`${this.props.id}-dropdown`}>
          <div className="u-flex u--mx-2 u-justify-between u-items-center">
            <div className="u-w-4/5 u-px-2">
              {filterInput}
            </div>
            <div className="u-w-1/5 u-px-2">
              {goButton}
            </div>
          </div>
          <ul style={style}>
            {options}
          </ul>
        </div>
      </li>
    );
  }
}
